export default {"src":"/_next/static/media/client-champion.9a118719.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};